/* eslint-disable no-bitwise */
import STREAM_TYPE_NIBBLE from '~/constants/STREAM_TYPE_NIBBLE';

const NIBBLE_STREAM_TYPE = Object.fromEntries(Object.entries(STREAM_TYPE_NIBBLE).map((kvp) => kvp.reverse()));

export default (uid = 0) => {
  const nibble = uid & 15;
  const streamType = NIBBLE_STREAM_TYPE[nibble];
  const userId = uid >> 4;
  return { userId, streamType };
};
